import React, { FC } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ScanType } from '@services';
import styles from './ScanTypeIconButtonComponent.module.scss';
import boddVariables from '../../../../variables.module.scss';
import ScanTypeComponent from '../ScanTypeComponent/ScanTypeComponent';

interface ScanTypeIconButtonComponentProps {
    scanId: string | undefined,
    scanType: ScanType | undefined,
    muted?: boolean,
}

interface ScanIconButtonProps {
    iconColor?: string,
}

const ScanIconButton = styled(IconButton, { shouldForwardProp: (prop) => prop !== 'iconColor' })<ScanIconButtonProps>((props: ScanIconButtonProps) => ({
    color: props.iconColor ?? boddVariables.boddBlack,
    padding: 0,
    '&:hover': {
        color: boddVariables.brandBlue,
    },
}));

const ScanTypeIconButtonComponent: FC<ScanTypeIconButtonComponentProps> = (props) => {
    const { scanId, scanType, muted } = props;

    const [tooltip, setTooltip] = React.useState(scanId && `Copy ${scanId}`);

    const handleClose = () => {
        setTooltip(scanId && `Copy ${scanId}`);
    };

    const handleClick = () => {
        if (scanId) {
            navigator.clipboard.writeText(scanId).then(() => setTooltip('Copied'));
        }
    };

    const color = scanId && muted ? boddVariables.warningOrange : boddVariables.boddBlack;

    return (
        <div className={styles.ScanTypeIconButtonComponent} data-testid="ScanTypeIconButtonComponent">
            <Tooltip title={tooltip} onClose={handleClose} onClick={handleClick} arrow>
                <div>
                    <ScanIconButton disabled={!scanId} iconColor={color}>
                        <ScanTypeComponent
                            color="inherit"
                            scanType={scanType}
                        />
                    </ScanIconButton>
                </div>
            </Tooltip>
        </div>
    );
};

export default ScanTypeIconButtonComponent;

ScanTypeIconButtonComponent.defaultProps = {
    muted: false,
};
